import { CmsObjectWithDefault } from '@components/Cms/types';

export type PhoneAssociationFormCmsKey =
    | 'pleaseEnterValidMobileNumber'
    | 'sendOtpButton'
    | 'phonenumberPlaceholder'
    | 'PhoneAssociationTitle1'
    | 'PhoneAssociationTitle2';

export const PhoneAssociationFormCmsWithDefault: CmsObjectWithDefault<PhoneAssociationFormCmsKey> = {
    pleaseEnterValidMobileNumber: {
        cmsId: 85560,
        defaultTranslation: 'Please enter a valid mobile number.',
    },
    sendOtpButton: {
        cmsId: 97925,
        defaultTranslation: 'Send OTP',
    },
    phonenumberPlaceholder: {
        cmsId: 82026,
        defaultTranslation: 'Mobile number',
    },
    PhoneAssociationTitle1: {
        cmsId: 82597,
        defaultTranslation: "Enter your mobile number and we'll send you a verification code to {0}",
    },
    PhoneAssociationTitle2: {
        cmsId: 126746,
        defaultTranslation: 'associate the number with your account',
    },
};
